import axios from 'axios';

import { conf } from '../confg';
import { store } from '../index';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  if (!token || token === 'undefined' || token === 'null') return {};
  return { Authorization: `Bearer ${token}` };
};

export const refreshGoldPrices = () => {
  const goldRequest = axios({
    url: conf.server_url + 'gold',
    method: 'GET',
    headers: authHeaders(),
  });

  const priceRequest = axios({
    url: conf.server_url + 'getGoldPrice',
    method: 'GET',
    headers: authHeaders(),
  });

  return Promise.all([goldRequest, priceRequest])
    .then(([goldResponse, priceResponse]) => {
      store.dispatch({
        type: 'update_price',
        payload: Math.ceil(goldResponse.data / 10000) * 10000,
      });
      store.dispatch({
        type: 'update_sell_price',
        payload: Math.ceil(priceResponse.data.sell / 10000) * 10000,
      });
      store.dispatch({
        type: 'update_buy_price',
        payload: Math.ceil(priceResponse.data.buy / 10000) * 10000,
      });
    })
    .catch(() => {
      // ignore gold refresh errors during pull-to-refresh
    });
};
